import { Container } from '@bit/ui-common.ui-components/ss-components';
import DataSet from './DataSet';
import { getPortalData } from '../../../utils/helpUtils';

export default Container({
    state: s => ({ commonData: s.commonData }),
    services: []
},
class ContactAFSP extends React.Component {
    constructor(props) { super(props); }
    render() {
        const
        { portal, commonData, space, theme, format, sort } = this.props,
        { CNTC } = commonData.textData.textDataStore;

        return (
            <div>
                <DataSet
                    title={'Help Desk Contact Information'}
                    type='CNTC'
                    format={format}
                    portal={portal}
                    data={getPortalData(CNTC, portal)}
                    space={space || null}
                    theme={theme || null}
                    sort={sort}
                />
            </div>
        );
    }
})
